<template>
  <a-card :bordered='false'>
    <div class="outBox">
      <div class="insideBox s_flex_ali">
        <p>1、您可以自定义兑换礼品的分类，方便管理兑换礼品的同时，也方便买家快速找到相关礼品进行兑换。
          <br />
          2、您可以添加一级和二级分类，可以自行选择分类样式。
          <br />
          3、添加完分类后，需要将已创建兑换的礼品进行关联，可在兑换列表页面进行批量设置分类；买家才能通过分类查找到礼品，关联的已上架兑换礼品数为0时，前端不显示该分类。
        </p>
      </div>
    </div>
    <div class='mb25 m-b-45 s_flex_ali m-t-25'>
      <span class='mr15'>
        <a-button type="primary" v-has:integralGiftOneCateAdd="visibleToggle">
          新增一级分类
        </a-button>
      </span>
      <span class='mr15' v-if="cateList.length">
        <a-button type="link" @click="changActiveKey">
          {{activeKey.length?'收起所有分类':'展开所有分类'}}
        </a-button>
      </span>
    </div>
    <a-collapse v-if="cateList.length" v-model:activeKey="activeKey">
      <a-collapse-panel :header="v.name" v-for="v  in cateList" :key="String(v.id)">
        <template #extra>
          <span class='p-r-400 ds-i-b '>
            <a-button type="link">
              礼品数量({{v.gift_total_count}})
            </a-button>
            <a-button type="link">
              已上架礼品数({{v.gift_online_total_count}})
            </a-button>
          </span>

          <a-button type="link" v-has:integralGiftTwoCateAdd="()=>{visibleToggle();group.pid=v.id;}">
            新增二级分类
          </a-button>-
          <a-button type="link" v-has:integralGiftOneCateEdit="()=>{group=JSON.parse(JSON.stringify(v));visible=true;}">
            修改
          </a-button>-
          <a-button type="link" v-has:integralGiftOneCateDel="()=>del(v.id)">
            删除
          </a-button>
        </template>
        <div>
          <div v-for="(value,key) in v.child" :key="key" class='p-t-15 p-b-15 p-l-100 secondCate s_flex_bian_c m-b-10'
            style="background:#ECECEC;">
            <div class="s_flex_ali">
              <img class="width-50 height-50 m-r-10" :src="value.pic?info.picdomain+value.pic:require('@/assets/images/normal.png')" alt="">
              <span class='width-100'>{{ value.name || '无' }}</span>
            </div>
            <div class='p-r-150'>
              <a-button type="link">
                礼品数量({{value.gift_total_count}})
              </a-button>
              <a-button type="link">
                已上架礼品数({{value.gift_online_total_count}})
              </a-button>
            </div>
            <div>
              <a-button type="link" v-has:integralGiftCateAddGift="()=>{selectGiftVisible=true;group.pid=value.id}">
                关联礼品
              </a-button>-
              <a-button type="link"
                v-has:integralGiftTwoCateEdit="()=>{group=JSON.parse(JSON.stringify(value));visible=true;}">
                修改
              </a-button>-
              <a-button type="link" v-has:integralGiftTwoCateDel="()=>del(value.id)">
                删除
              </a-button>
            </div>
          </div>
        </div>
        <a-divider type="vertical" />
      </a-collapse-panel>
    </a-collapse>
    <a-empty v-if="!cateList.length" :description="false" />
  </a-card>
  <!-- 添加分类 -->
  <a-modal  :keyboard="false" title="分类管理" centered v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    destroyOnClose>
    <a-form ref="groupForm" :model="group" :label-col="{span:4}" :wrapper-col="{span:20}" help='限8个字符'>
      <a-form-item ref="name" label="分组名称" name="name"
        :rules="[{ required: true, message: '请输入分类名称' },{ max: 8, message: '分组名称不超过8个字符' }]">
        <a-input v-model:value="group.name" placeholder='请输入分类名称' :max='8' />
      </a-form-item>
      <a-form-item ref="pic" label="分组图片" name="pic" :rules="[{ required: true, message: '请上传分组图片' }]" v-if='group.pid'>
        <material :groupType='1' :image="group.pic" :max="1" v-on:handlechoose="(data)=>{ group.pic=data}" v-on:handledel="group.pic=''" />
      </a-form-item>
      <a-form-item ref="id" label="id" name="id" hidden v-if="group.id">
        <a-input v-model:value="group.id" />
      </a-form-item>
      <a-form-item ref="pid" label="pid" name="pid" hidden v-if="group.pid">
        <a-input v-model:value="group.pid" />
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 关联礼品 -->

  <a-modal  :keyboard="false" title='关联礼品' v-model:visible="selectGiftVisible" :footer="null" :confirm-loading="confirmLoading"
    @ok="handleSelectGift" destroyOnClose :width='1300'>
    <selectGift :selectList="selectList" :checkout="true" v-on:select="select" />
  </a-modal>
</template>
<script>
  import { iscode } from "@/utils/app";
  import { onMounted, reactive, toRefs, ref, watch } from "vue";
  import {
    getCategory,
    createCategory,
    updateCate,
    deleteCate,
    updateAllCate
  } from "@/api/integralShop.js";
  import { getToken } from "@/libs/util";
  import { Modal } from "ant-design-vue";
  import { useTree } from '@/hooks/useTree.js'
    import store from "@/store";
  export default {
    name: "product",
    setup(props) {
      const state = reactive({
        info:store.state.user.info,
        cateList: [],
        visible: false,
        confirmLoading: false,
        activeKey: [],
        selectGiftVisible: false,//关联礼品弹窗
        selectList: [],//被选择的礼品
      });
      const initData = async () => {
        let result = await getCategory().then((res) => res.data);
        state.cateList = useTree(result.data);
      };
      watch(state.visible, () => {
        groupForm.value.resetFields();
      });

      // 定义分类表单绑定数据
      const group = ref({ name: "", sort: 100 });
      // 定义分类表单ref
      const groupForm = ref();
      // 提交
      const handleOk = () => {
        groupForm.value
          .validate()
          .then(async (res) => {
            state.confirmLoading = true;
            var result;
            if (!res.id) {
              // 新增分类
              result = await createCategory(res);
            } else {
              // 修改分类
              result = await updateCate({ id: res.id, ...res });
            }
            if (iscode(result.data, true)) {
              state.visible = false;
              initData();
              groupForm.value.resetFields();
            }
            state.confirmLoading = false;
          })
          .catch((error) => { });
      };
      // // 弹出表单
      const visibleToggle = () => {
        group.value = { name: "", sort: 100, id: null, pid: null };
        state.visible = true;
        //  groupForm.value.resetFields();
      };
      // 删除
      const del = (id) => {
        Modal.confirm({
          centered: true,
          content: "删除后将无法恢复，您确定要删除吗？",
          onOk: async () => {
            let res = await deleteCate({ id: id }).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      const changActiveKey = () => {
        if (state.activeKey.length) {
          state.activeKey = [];
        } else {
          state.activeKey = [];
          state.cateList.forEach((v, key) => {
            state.activeKey.push(v.id);
          });
          console.log(state.activeKey)
        }
      };
      // 选中
      const select = async (e) => {
        var ids = []
        console.log(e)
        if (typeof e !== 'object' ||
          Array != e.constructor) {
          ids = [e.id]
        } else {
          e.forEach(v => {
            ids.push(v.id)
          })
        }
        let result = await updateAllCate({ id:ids, category_id: group.value.pid }).then(res => res.data).catch(error => error)
        if (iscode(result, true)) {
          state.selectGiftVisible = false
          initData();
        }
        // 关联礼品逻辑
      }
      onMounted(() => {
        initData();
      });
      return {
        ...toRefs(state),
        handleOk,
        group,
        groupForm,
        del,
        visibleToggle,
        changActiveKey,
        getToken,
        select
      };
    },
  };
</script>